import Icon from '@/components/Icon'
import Button from '@/components/Button'
import { MODAL_ID } from '@/constants/modalId'
import { showModal } from '@/components/Modals/ModalV2'
import { classNames } from '@/util/tailwindHelpers'
import { SelectionModalDisabledMessage } from './types'

interface SelectionModeOptionProps {
  icon: string
  disabled?: boolean
  className: string
  theme?: 'white' | 'green-arcade-secondary'
  title: string
  disabledMessage?: SelectionModalDisabledMessage
  onClick: () => void
}

export const SelectionModeOption = ({
  icon,
  disabled,
  className,
  theme = 'white',
  title,
  disabledMessage,
  onClick
}: SelectionModeOptionProps) => {
  const handleOnClick = () => {
    if (disabled && disabledMessage) {
      showModal(MODAL_ID.boolean, {
        title: disabledMessage.title,
        children: disabledMessage.message,
        primaryButton: {
          label: 'OK',
          theme: 'blue',
          onClick: () => {}
        }
      })
    } else {
      onClick()
    }
  }

  return (
    <Button
      size="sm"
      className={classNames(
        'flex items-center justify-center gap-1',
        className
      )}
      theme={theme}
      onClick={handleOnClick}
    >
      <Icon name={icon} className="w-[20px] h-[20px] mr-1" />
      {title}
    </Button>
  )
}
